import { palette } from '@dev/ee-components';
import {
    EditorFontStyleOptions,
    EditorFontWeightOptions,
    EditorPositionAlign,
    EditorTextAlign,
    EditorTextDecorationOptions,
} from '@dev/template-editor';

export const websiteStyles = {
    minContentWidth: 480,
    maxContentWidth: 1440,
    disableBackgroundImage: false,
    disableBackgroundColor: false,
    formAttributes: {
        spacing: 24,
        backgroundColor: '#EFEFFA',
        padding: {
            paddingTop: 20,
            paddingBottom: 20,
            paddingLeft: 20,
            paddingRight: 20,
        },
    },
    formBlockAttributes: {
        spacing: 24,
        backgroundColor: null,
        padding: {
            paddingTop: 20,
            paddingBottom: 20,
            paddingLeft: 20,
            paddingRight: 20,
        },
    },
    inputsAttributes: {
        fontSize: 16,
        color: palette.jacarta[5],
        fontWeight: EditorFontWeightOptions.NORMAL,
        fontStyle: EditorFontStyleOptions.NORMAL,
        textDecoration: EditorTextDecorationOptions.NONE,
        backgroundColor: palette.basic.paper,
        borderColor: '#1E0E3F',
        textAlign: EditorTextAlign.LEFT,
        borderRadius: 4,
        letterSpacing: 0,
        padding: {
            paddingTop: 10,
            paddingBottom: 10,
            paddingLeft: 10,
            paddingRight: 10,
        },
        placeholder: {
            color: palette.gray[5],
            fontWeight: EditorFontWeightOptions.NORMAL,
            fontStyle: EditorFontStyleOptions.NORMAL,
            textDecoration: EditorTextDecorationOptions.NONE,
        },
        label: {
            letterSpacing: 0,
            color: palette.jacarta[5],
            fontSize: 16,
            fontWeight: EditorFontWeightOptions.BOLD,
            fontStyle: EditorFontStyleOptions.NORMAL,
            textDecoration: EditorTextDecorationOptions.NONE,
            textAlign: EditorTextAlign.LEFT,
        },
    },
    buttonAttributes: {
        backgroundColor: '#5457FF',
        position: EditorPositionAlign.CENTER,
        borderRadius: 4,
        color: '#FFFFFF',
        fontWeight: EditorFontWeightOptions.BOLD,
        fontStyle: EditorFontStyleOptions.NORMAL,
        textDecoration: EditorTextDecorationOptions.NONE,
        fontSize: 16,
        borderColor: '#5457FF',
        padding: {
            paddingTop: 12,
            paddingBottom: 12,
            paddingLeft: 24,
            paddingRight: 24,
        },
    },
};
